import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { DocumentOpenerPort } from './document-opener.port';

@Injectable({ providedIn: 'root' })
export class WebDocumentOpenerService implements DocumentOpenerPort {
  private readonly document = inject(DOCUMENT);

  async open(resolveUrl: () => Promise<string>): Promise<void> {
    const view = this.document.defaultView;
    // Must be synchronous (before any await) to keep the user gesture and avoid popup blockers.
    const popup = view?.open('', '_blank') ?? null;

    let url: string;
    try {
      url = await resolveUrl();
    } catch (error) {
      popup?.close();
      throw error;
    }

    if (popup) {
      popup.opener = null;
      popup.location.href = url;
    } else if (view) {
      view.location.href = url;
    }
  }
}
